import React from 'react';
import { isEmpty } from 'lodash';
import { motion } from 'framer-motion';
import Link from '../layouts/Link';
import Icons from '../layouts/Icons';

export default function FooterBottom({ copyrightText, socialMediaLinks, bottomLinks }) {
  return (
    <div
      className="bg-bg-2 lg:h-[104px] h-[135px] w-full 4xl:px-[160px] 2xl:px-[100px] xl:px-[40px]
      lg:px-[80px] px-4 flex lg:flex-row flex-col lg:justify-between justify-center
      lg:items-center lg:gap-y-0 gap-y-5"
    >
      <motion.p
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0.4 }}
        viewport={{ once: true }}
        className="text-white font-roboto-regular md:text-[13px] text-[12px] leading-[20px]"
      >
        {copyrightText.replace('{{YEAR}}', new Date().getFullYear())}
      </motion.p>
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0.4 }}
        viewport={{ once: true }}
        className="flex flex-col md:flex-row 2xl:gap-[131px] xl:gap-[50px] md:gap-[20px] gap-[20px] justify-between"
      >
        <div className="flex 2xl:gap-x-[68px] xl:gap-x-[50px] md:gap-x-[20px] gap-x-[13px]">
          {isEmpty(bottomLinks) ||
            bottomLinks.map((links, index) => (
              <Link
                to={links.url}
                key={index}
                className="text-white font-roboto-regular md:text-[13px] text-[12px]
                leading-[20px]"
              >
                {links.name}
              </Link>
            ))}
        </div>
        <div className="flex md:gap-[18px] gap-[12px] social-media">
          {socialMediaLinks?.instagram && (
            <a
              target="_blank"
              rel="noreferrer"
              aria-label="instagram"
              href={socialMediaLinks.instagram}
              className="w-[24px] h-[24px] instagram"
            >
              <Icons icon="instagram" className="fill-white instagram" />
            </a>
          )}
          {socialMediaLinks?.facebook && (
            <a
              target="_blank"
              rel="noreferrer"
              aria-label="facebook"
              href={socialMediaLinks.facebook}
              className="w-[24px] h-[24px] facebook"
            >
              <Icons icon="facebook" className="fill-white facebook" />
            </a>
          )}
          {socialMediaLinks?.twitter && (
            <a
              target="_blank"
              rel="noreferrer"
              aria-label="twitter"
              href={socialMediaLinks.twitter}
              className="w-[24px] h-[24px] twitter"
            >
              <Icons icon="twitter" className="fill-white twitter" />
            </a>
          )}
          {socialMediaLinks?.youtube && (
            <a
              target="_blank"
              rel="noreferrer"
              aria-label="youtube"
              href={socialMediaLinks.youtube}
              className="w-[24px] h-[24px] youtube"
            >
              <Icons icon="youtube" className="fill-white svg-child2:fill-white youtube" />
            </a>
          )}
          {socialMediaLinks?.tikTok && (
            <a
              target="_blank"
              rel="noreferrer"
              aria-label="tiktok"
              href={socialMediaLinks.tikTok}
              className="w-[24px] h-[24px] tiktok"
            >
              <Icons icon="tiktok" className="fill-white tiktok" />
            </a>
          )}
        </div>
      </motion.div>
    </div>
  );
}